





















import { Vue, Component, Mixins, Prop } from "vue-property-decorator";

import MyForm from "@/mixins/form";

@Component
export default class extends Mixins(MyForm) {
  @Prop() stadiumId!: number;

  tags: any[] = [];

  tagsval: any[] = [];

  handleSubmit() {
    this.form.validateFields((err: any, values: any) => {
      if (!err) {
        this.showTsConfirm({
          title: "确认信息",
          content: "确定要提交吗？",
          onOk: async () => {
            // console.log(values)
            const res = await this.$store.dispatch("stadium/saveStadiumTags", {
              stadium_id: this.stadiumId,
              ...values,
            });

            if (res && res.Message && res.Message === "success") {
              this.$message.success(res.Message);
            } else {
              this.$message.error(res.Message);
            }
          },
        });
      }
    });
  }

  async mounted() {
    // tags选项
    const res = await this.$store.dispatch("stadium/getTags", {});
    if (res && res.Data) {
      this.tags = res.Data;
    }
    // 加载场馆信息
    const res1 = await this.$store.dispatch("stadium/getStadiumTags", {
      stadium_id: this.stadiumId,
    });
    if (res1 && res1.Data) {
      this.tagsval = res1.Data;
    }
  }
}
